export const menuCategories = [
  'All',
  'StayHome',
  'Jackets',
  'Hoodies',
  'Men',
  'Women',

  'Accessories',
  'Shoes',
]

export const sortingOptions = [
  { label: '熱賣商品', value: '1', selected: true },
  { label: '最新上架', value: '2' },
  { label: '最多人看', value: '3' },
  { label: '價格低到高', value: '4' },
  { label: '價格高到低', value: '5' },
]

export const pageSizeOptions = [
  { label: '16筆', value: '16' },
  { label: '32筆', value: '32', selected: true },
]
